var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.75V13.5h5v6.25c0 .687.563 1.25 1.25 1.25h3.75c.688 0 1.25-.563 1.25-1.25V11h2.125c.575 0 .85-.713.413-1.088L12.838.5a1.26 1.26 0 0 0-1.675 0L.713 9.912C.288 10.287.55 11 1.125 11H3.25v8.75c0 .687.563 1.25 1.25 1.25h3.75c.688 0 1.25-.563 1.25-1.25Z",
    fill: "#fff"
  })));
};
export default SvgHome;